import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInputValidation, getInputData } from '../../store/forms';
import doValidations from './doValidations';

const useCheckin1Validation = (saveValidation) => {
	const [valid, setValid] = useState(true);

	const view = "checkin1";
	const object = "driverData";
	const name = useSelector(getInputData(view, object, "name"));
	const phone = useSelector(getInputData(view, object, "phone"));
	const email = useSelector(getInputData(view, object, "email"));
	const adress = useSelector(getInputData(view, object, "adress"));
	const commune = useSelector(getInputData(view, object, "commune"));

	const dispatch = useDispatch();
	const handleValidation = (id, valid, text) => {
		if (saveValidation) {
			dispatch(setInputValidation({ validation: { valid, text }, object, input: id, view }));	
		}
	};
	const notNullString = (string) => string !== '';
	const isNumber = (number) => !isNaN(number);
	const isPhoneLength = (number) => number.length < 12 && number.length > 7;
	
	const validations = [
		{
			id: 'name',
			text: 'Ingrese nombre y apellido',
			valid: () => notNullString(name.data),
		},
		{
			id: 'phone',
			text: 'Ingrese un número de teléfono',
			valid: () => notNullString(phone.data),
		},
		{
			id: 'phone',
			text: 'Teléfono debe ser un número',
			valid: () => isNumber(phone.data),
		},
		{
			id: 'phone',
			text: 'Télefono debe tener entre 8 y 11 números',
			valid: () => isPhoneLength(phone.data),
		},
		{
			id: 'email',
			text: 'Ingrese un email valido',
			valid: () => notNullString(email.data),
		},
		{
			id: 'adress',
			text: 'Ingrese su dirección',
			valid: () => notNullString(adress.data),
		},
		{
			id: 'commune',
			text: 'Seleccione una comuna',
			valid: () => notNullString(commune.data),
		}
	];
	useEffect(() => {
		doValidations(validations, setValid, handleValidation);
	}, [name.data, phone.data, email.data, adress.data, commune.data]); // eslint-disable-line react-hooks/exhaustive-deps
	return valid;
}

export default useCheckin1Validation;
